import { addDays, todayBusinessDate } from '../../dates/index.js';
import { SALES_ORDER_PAYMENT_CONSTRAINTS } from './payment-constraints.js';
/**
 * The latest payment date accepted at `now`: calendar days from Pacific today (D24), not 24-hour
 * steps from now. The record-payment schema and the payment dialog's picker read this one rule.
 */
export function lastAllowedPaymentDate(now = new Date()) {
    return addDays(todayBusinessDate(now), SALES_ORDER_PAYMENT_CONSTRAINTS.paymentDate.maxDaysInFuture);
}
//# sourceMappingURL=last-allowed-payment-date.js.map